var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 5.334a2 2 0 0 1 2-2h2.667c.513 0 .98.193 1.334.51.353-.317.82-.51 1.333-.51h2.667a2 2 0 0 1 2 2v1.512c.398.23.666.661.666 1.155v4.666h-.666l-.5-1.333h-11L2 12.667h-.667V8.001c0-.494.268-.925.667-1.155V5.334Zm10.667 1.333V5.334a.667.667 0 0 0-.666-.667H9.334a.667.667 0 0 0-.667.667v1.333h4Zm-5.333 0V5.334a.667.667 0 0 0-.667-.667H4.001a.667.667 0 0 0-.667.667v1.333h4Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.2dec31aad60cd8e27d0336aafeddf224.svg";
export { ForwardRef as ReactComponent };